export default __webpack_public_path__ + "static/media/wrapper.37c3aafd.svg";